import React from 'react';
import { Link } from 'react-router-dom';

import SettingsProfile from './SettingsProfile';
import SettingsPassword from './SettingsPassword';
import Title from '../shared/Title';

const Settings = ({ userData, section }) => (
  <div className="s-settings">
    <Title
      title="Settings"
      subtitle=" Choose a team from this list to see its data"
    />

    <section className="s-settings__container">
      <div className="s-settings__nav">
        <nav className="nav-pills">
          <Link
            to={'/settings'}
            className={
              'nav-pills__item ' + (section === 'profile' ? 'is-active' : '')
            }
          >
            My Profile
          </Link>
          <Link
            to={'/settings-password'}
            className={
              'nav-pills__item ' + (section === 'password' ? 'is-active' : '')
            }
          >
            Password
          </Link>
        </nav>
      </div>
      <div className="s-settings__content">
        {
          {
            profile: <SettingsProfile userData={userData} />,
            password: <SettingsPassword userData={userData} />,
          }[section]
        }
      </div>
    </section>
  </div>
);

export default Settings;
